import { isProfileLoading } from 'platform/user/selectors';
import { loadingTogglesSelector } from 'platform/utilities/feature-toggles/useFeatureToggle';

/**
 * Select whether the app should wait to render because feature toggles or the
 * user profile are still loading.
 *
 * @param {Object} state - Redux state
 * @returns {boolean} true while either feature toggles or the profile load
 */
export const selectIsAppLoading = state =>
  Boolean(loadingTogglesSelector(state) || isProfileLoading(state));
